module.exports = __webpack_public_path__ + "images/emoji/bowtie.da291f00ec1def23619c.png";